import React, { useCallback, useRef } from 'react';
import { ParticipantVideoSidebar } from './ParticipantVideo';
import { useCallTiles, type CallTileLayoutProps } from './callTileProps';
import {
  SidebarContainer,
  SidebarScrollArea,
  SIDEBAR_TILE_HEIGHT,
  SIDEBAR_TILE_WIDTH,
  SIDEBAR_TILE_GAP,
} from '../styles/LiveKitVideoDisplay.styles';
import type { PanelPosition } from '../types/LiveKitVideoDisplay.types';

interface SidebarVideoDisplayProps extends CallTileLayoutProps {
  panelPosition: PanelPosition;
}

export const SidebarVideoDisplay: React.FC<SidebarVideoDisplayProps> = ({ panelPosition, ...layout }) => {
  const sidebarScrollRef = useRef<HTMLDivElement>(null);

  const getViewportCapacity = useCallback(() => {
    const scrollArea = sidebarScrollRef.current;
    if (!scrollArea) return 0;
    return panelPosition === 'top'
      ? Math.floor(scrollArea.clientWidth / (SIDEBAR_TILE_WIDTH + SIDEBAR_TILE_GAP))
      : Math.floor(scrollArea.clientHeight / (SIDEBAR_TILE_HEIGHT + SIDEBAR_TILE_GAP));
  }, [panelPosition]);

  const { order, tileProps } = useCallTiles(layout, getViewportCapacity);

  return (
    <SidebarContainer panelPosition={panelPosition}>
      <SidebarScrollArea ref={sidebarScrollRef} panelPosition={panelPosition}>
        {order.map((participantId) => {
          const participant = layout.participants.find(p => p.identity === participantId);
          if (!participant) return null;
          return (
            <ParticipantVideoSidebar
              key={`sidebar-${participant.isLocal ? 'local' : 'remote'}-${participantId}`}
              {...tileProps(participant)}
              panelPosition={panelPosition}
            />
          );
        })}
      </SidebarScrollArea>
    </SidebarContainer>
  );
};
